import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const serviceLocationAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'serviceLocationAPI',
    endpoints: (builder) => ({

        // Define mutation to update client service location
        updateClientServiceLocation: builder.mutation({
            query: (data) => ({
                url: '/ServiceLocation/UpdateClientServiceLocations',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Define mutation to update department service location
        updateDepartmentServiceLocation: builder.mutation({
            query: (data) => ({
                url: '/ServiceLocation/UpdateDepartmentServiceLocations',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

// Destructure mutations for client and department service location updates
export const {
    useUpdateClientServiceLocationMutation,
    useUpdateDepartmentServiceLocationMutation
} = serviceLocationAPI;

// Export the serviceLocationAPI
export default serviceLocationAPI;
